import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetFamilyDetails() {
  const { id } = useParams();
  return useQuery(['employement-family-details'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_FAMILY_DETAILS_API, {
        employee_id: id,
      })
    );
    return res.data;
  });
}
